import { Button } from 'primereact/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SaveButton.module.scss';

interface PrimaryButtonProps {
  onClick: () => void;
  loading?: boolean;
}

export const SaveButton: FC<PrimaryButtonProps> = ({ onClick, loading }) => {
  const { t } = useTranslation();
  return (
    <Button
      label={t('common.save')}
      icon="pi pi-save"
      onClick={onClick}
      loading={loading}
      className={styles.button}
      pt={{
        root: {
          style: {
            backgroundColor: 'var(--primary-color)',
            borderColor: 'var(--primary-color)',
            color: 'var(--primary-color-text)',
          },
        },
        icon: { style: { color: 'var(--primary-color-text)' } },
      }}
    />
  );
};
